import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ["modal", "modalBodyDefault", "modalBody"]

  static values = {
    outsideOpenId: String,
    outsideOpenTarget: String,
    hiddenByDefault: { type: Boolean, default: true },
  }

  connect() {
    if (this.hiddenByDefaultValue) {
      this.modalTarget.classList.add("hidden")
    } else {
      this.modalTarget.classList.remove("hidden")
    }

    if (this.outsideOpenTargetValue) {
      document.querySelectorAll(this.outsideOpenTargetValue).forEach(element => {
        element.onclick = this.show.bind(this)
      })
    }

    if (this.outsideOpenIdValue) {
      document.getElementById(this.outsideOpenIdValue).onclick = this.show.bind(this)
    }
  }

  show(event) {
    const { isPlanChange, planId, plan, forcePayment } = event.target.dataset
    this.modalTarget.classList.toggle("hidden")

    const params = {
      new_plan: planId,
      force_payment: forcePayment === "true",
    }

    Rails.ajax({
      type: 'post',
      url: '/get_restrictions_modal_content',
      dataType: 'json',
      data: new URLSearchParams(params),
      success: (data) => {
        this.modalBodyDefaultTarget.classList.add("hidden")
        this.modalBodyTarget.innerHTML = data.content
        if (data.status === 'change') {
          if (data.without_payment) {
            if (plan.includes("_free.0")) {
              window.TurboNativeBridge.postMessage("sendEvent", { event: "change_plan_to_micro" })
            }
            this.hide()
            Turbo.cache.clear()
            Turbo.visit("/account/info", { action: "replace" })
          } else {
            window.TurboNativeBridge.postMessage("payment", { plan, apps_id: data.apps_id, is_plan_change: isPlanChange === "true" })
          }
        }
      }
    })
  }

  hide() {
    this.modalTarget.classList.toggle("hidden")
    this.modalBodyTarget.innerHTML = ''
    this.modalBodyDefaultTarget.classList.remove("hidden")
  }
}
